import { HospitalRocotime, HospitalAgency, HospitalProperties, HospitalFlags } from '@/infrastructure/network/Monitaro/schema/models'
import PriceEntity, { IPriceProps } from '@/entities/Price'
import AgencyEntity, { IAgencyProps } from '@/entities/Agency'
import AreaEntity, { IAreaProps } from '@/entities/Area'

export interface IHospitalProps {
  id?: string
  price?: IPriceProps | null
  priceId: string | null
  agencies?: IAgencyProps[]
  areas?: IAreaProps[]
  name: string | null
  kana: string | null
  chargeable: boolean | null
  approved: boolean | null
  activation: boolean | null
  rocotime: HospitalRocotime | null
  agency: HospitalAgency | null
  properties: HospitalProperties | null
  flags: HospitalFlags | null
  doctorsCount?: number
  usersCount?: number
  term?: number | null
  startedAt: string | null
  createdAt: string | null
  updatedAt: string | null
}

export default class HospitalEntity {
  private _props: IHospitalProps

  constructor(props?: IHospitalProps | null) {
    this._props = EmptyHospitalPropsFactory(props)
  }

  get props(): IHospitalProps {
    return this._props
  }

  get clone(): IHospitalProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get price(): PriceEntity | null | undefined {
    return new PriceEntity(this._props.price)
  }

  get priceId(): string | null {
    return this._props.priceId
  }

  get agencies(): AgencyEntity[] | undefined {
    return this._props.agencies ? this._props.agencies.map((prop) => new AgencyEntity(prop)) : []
  }

  get areas(): AreaEntity[] | undefined {
    return this._props.areas ? this._props.areas.map((prop) => new AreaEntity(prop)) : []
  }

  get name(): string | null {
    return this._props.name
  }

  get kana(): string | null {
    return this._props.kana
  }

  get rocotime(): HospitalRocotime | null | undefined {
    return this._props.rocotime
  }

  get agency(): HospitalAgency | null | undefined {
    return this._props.agency
  }

  get properties(): HospitalProperties | null | undefined {
    return this._props.properties
  }

  get flags(): HospitalFlags | null | undefined {
    return this._props.flags
  }

  get doctorsCount(): number | undefined {
    return this._props.doctorsCount
  }

  get usersCount(): number | undefined {
    return this._props.usersCount
  }

  get startedAt(): string | null {
    return this._props.startedAt
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const headers = [{ text: '病院名', value: 'name' }]

export const EmptyHospitalPropsFactory = (props?: Partial<IHospitalProps> | null): IHospitalProps => ({
  priceId: null,
  name: null,
  kana: null,
  chargeable: null,
  approved: null,
  activation: null,
  rocotime: null,
  agency: null,
  properties: null,
  flags: null,
  startedAt: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
